<template>
  <img src="~/assets/icon/icon-lock.svg" />
</template>
